import { bsc, bscTestnet } from "wagmi/chains";
export const chains = [ bsc];
